import Vue from 'vue'
import date from '../lib/date'

Vue.mixin({
  ...date
})
